/**
 * @desc 报关信息导入
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(body: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/import/skuCustomsClearance`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
